import { Accordion as AccordionComponent } from './Accordion';
import { Item } from './Item';

export const Accordion = Object.assign(AccordionComponent, {
    Item: Item
});
